import Preloader from './Preloader'
import PageTransition from './PageTransition'

export const onLoad = () => {
	let preloader = new Preloader(document.querySelector('.preloader'))
	let pagetransition = new PageTransition(document.querySelector('.site-intro'))

	// IF FIRST VISIT, SHOW PRELOADER
	const hasVisited = sessionStorage.getItem('hasVisited');
	// const hasVisited = 'false';
	
	if (hasVisited === 'false' || hasVisited == null){
		// let preloader = new Preloader(document.querySelector('.preloader'))
		window.emitter.on('pageLoaded', pagetransition.init)

		preloader.init()

		sessionStorage.setItem('hasVisited', 'true');
	} else {
		// preloader.destroyElement()
		pagetransition.init()
	}
};
